import AddIcon from '@mui/icons-material/Add';
import CheckIcon from '@mui/icons-material/Check';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Box, Button, CircularProgress, MenuItem, Stack, Typography } from '@mui/material';
import { observer } from 'mobx-react';
import React, { useState } from 'react';

import { useI18n } from '../../../../../../application/language/useI18n';
import { ProjectInfoDomain } from '../store/ProjectInfoDomain';
import { getInvitationLink, lowercaseRoleFirst } from './utils';
import { Colors } from '../../../../../design/color/Colors';

export interface IInvitationLinkListProperties {
  domain: ProjectInfoDomain;
  projectId: string;
  handleNewInvitationLink: () => void;
  handleClose: () => void;
}

export const InvitationLinkList = observer(
  ({ domain, projectId, handleNewInvitationLink, handleClose }: IInvitationLinkListProperties) => {
    const { translate } = useI18n();
    const [copiedId, setCopiedId] = useState('');
    const [loading] = useState(false);

    const links = domain.ui.invitationLinks.list || [];

    const handleCopy = (link) => {
      const invitationLink = getInvitationLink(link);
      navigator.clipboard.writeText(invitationLink);
      setCopiedId(link.id);
      setTimeout(handleClose,400)
    };

    const getIcon = (linkId) =>
      copiedId === linkId ? (
        <CheckIcon sx={{ mt: 0.5, fontSize: 20, color: Colors.primaryLight }} />
      ) : (
        <ContentCopyIcon sx={{ mt: 0.5, fontSize: 20, color: Colors.primaryLight }} />
      );

    return (
      <>
        <Box sx={{ height: '400px', width: '420px', overflowY: 'auto', p: 1 }}>
          {loading ? (
            <CircularProgress />
          ) : (
            links.map((link, i) => (
              
              <MenuItem key={link.id} sx={{ whiteSpace: 'normal' }} onClick={() => handleCopy(link)}>
                <Stack sx={{ minHeight: '40px' }} direction="row" gap={2}>
                  {getIcon(link.id)}
                
                  <Typography
                    sx={{
                      whiteSpace: 'normal',
                      wordBreak: 'break-word',
                      overflowWrap: 'break-word',
                      mr: 4,
                      width: '100%',
                    }}
                  >
                    {!i && `${translate('phrases.for')} `}
                    {link.abledRoles.map((item) => lowercaseRoleFirst(item.name)).join(', ')}
                  </Typography>
                </Stack>
              </MenuItem>
            ))
          )}
        </Box>

        <Box
          sx={{
            position: 'sticky',
            bottom: 0,
            backgroundColor: Colors.bgElevated,
            zIndex: 1,
            p: 2,
            textAlign: 'center',
          }}
        >
          <Button
            sx={{ width: '100%', fontSize: 16, color: Colors.primaryLight }}
            startIcon={<AddIcon sx={{ fontSize: 24 }} />}
            onClick={handleNewInvitationLink}
          >
            {translate('phrases.newInvitationLink')}
          </Button>
        </Box>
      </>
    );
  },
);
